import React, { Fragment, useState } from "react";
import classNames from "classnames/bind";
import ReactPlayer from "react-player";
import {
  OffStatus,
  OnStatusGreen,
  MenuIcon,
  CloseIcon,
  Close,
} from "../../../components/Icons/Icons";
import { CameraContext } from "../LiveCamera";
import streamingClient from "../../../services/streamingClient";
import WHEPPlayer from "../../../components/WebRtc/WebRtc";
import styles from "./CameraActive.module.css";

const cx = classNames.bind(styles);
const CameraActive = ({ item }) => {
  const { cameraActive, stream } = React.useContext(CameraContext);
  const [reload, setReload] = useState(false);

  return (
    <div className={cx("container")}>
      <div className={cx("content")}>
        {stream &&
          stream.length > 0 &&
          stream.map((item, index) => {
            return (
              <Fragment key={index}>
                {item?.rtc ? (
                  <WHEPPlayer
                    channelUrl={item.rtc}
                    reload={reload}
                    setReload={setReload}
                  />
                ) : (
                  <ReactPlayer
                    className="react-player"
                    width={"100%"}
                    height={"100%"}
                    playing={true}
                    muted={true}
                    url={item?.url}
                  />
                )}
                <div className={cx("setting")}>
                  <div style={{ width: "60%" }} className={cx("name_status")}>
                    <span className={cx("On")}>
                      {item?.status === "On" ? (
                        <OnStatusGreen />
                      ) : (
                        <OffStatus />
                      )}
                    </span>

                    <span
                      style={{ fontSize: 12, maxWidth: "100%" }}
                      className={cx("name")}
                    >
                      {item?.name}
                    </span>
                  </div>
                </div>
              </Fragment>
            );
          })}
      </div>
    </div>
  );
};

export default CameraActive;
